import { render, staticRenderFns } from "./DatosTercero.vue?vue&type=template&id=4cf2400e&scoped=true&"
import script from "./DatosTercero.vue?vue&type=script&lang=js&"
export * from "./DatosTercero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2400e",
  null
  
)

export default component.exports